var app = angular.module("leonardo");

var PropertyStates = function($stateProvider) {
  $stateProvider.state('portfolios.property-edit', {
    url: "/property/:pk/edit",
    title: 'Edit Property',
    params: {
      pk: '',
      squash: false
    },
    cssClass: 'page-property-edit',
    action: 'edit',
    views: {
      'filters@authenticated.layout-main': {},
      'content@authenticated.layout-main': {
        controller: 'PropertyForm',
        templateUrl: 'views/templates/property/form.html'
      }
    },
    resolve: {
      propertyObj: ['PropertyService', '$stateParams', function(PropertyService, $stateParams) {
        return PropertyService.get($stateParams.pk);
      }]
    },
    ncyBreadcrumb: {
      label: 'Property edit'
    }
  });

  $stateProvider.state('portfolios.property-add', {
    url: "/:pk/property/add",
    title: 'Add Property',
    params: {
      pk: '',
      squash: false
    },
    cssClass: 'page-property-add',
    action: 'create',
    views: {
      'filters@authenticated.layout-main': {},
      'content@authenticated.layout-main': {
        controller: 'PropertyForm',
        templateUrl: 'views/templates/property/form.html'
      }
    },
    resolve: {
      propertyObj: ['PortfolioService', 'PropertyService', 'AuthDataService', '$stateParams', '$q', function(PortfolioService, PropertyService, AuthDataService, $stateParams, $q) {
        var defer = $q.defer();
        PortfolioService.get($stateParams.pk).then(function (data) {
          defer.resolve(PropertyService.bulkObject(data.account, data.id));
        });
        return defer.promise;
      }]
    },
    ncyBreadcrumb: {
      label: 'Add Property'
    }
  });
};

app.config(['$stateProvider', PropertyStates]);
